import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import Cookies from "js-cookie";

const initialState = {
    wishlist: Cookies.get("wishlist")
        ? JSON.parse(Cookies.get("wishlist"))
        : [],
    total: Cookies.get("total")
        ? JSON.parse(Cookies.get("total"))
        : 0,
    totalItems: Cookies.get("totalItems")
        ? JSON.parse(Cookies.get("totalItems"))
        : 0,
}

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {
        addToWishlist: (state, action) => {
            const item = action.payload
            state.wishlist.push(item)
            state.totalItems++
            state.total += item.price
            Cookies.set("wishlist", JSON.stringify(state.wishlist))
            Cookies.set("total", JSON.stringify(state.total))
            Cookies.set("totalItems", JSON.stringify(state.totalItems))
            toast.success("Item added to wishlist")
        },

        removeFromWishlist: (state, action) => {
            const itemId = action.payload
            const index =
                state.wishlist
                    .findIndex(
                        (item) => item._id === itemId)

            if (index >= 0) {

                state.totalItems--
                state.total -= state.wishlist[index].price
                state.wishlist.splice(index, 1)
                Cookies.set("wishlist", JSON.stringify(state.wishlist))
                Cookies.set("total", JSON.stringify(state.total))
                Cookies.set("totalItems", JSON.stringify(state.totalItems))
                toast
                    .success("Item removed from wishlist")
            }
        },
        resetWishlist: (state) => {
            state.wishlist = [];
            state.total = 0;
            state.totalItems = 0;
            Cookies.set("wishlist", JSON.stringify([]));
            Cookies.set("total", JSON.stringify(0));
            Cookies.set("totalItems", JSON.stringify(0));
            toast.success("Wishlist reset");
        },
    }
})

export const
    {
        addToWishlist, resetWishlist,
        removeFromWishlist
    } = wishlistSlice.actions

export default wishlistSlice.reducer;